import { ShortDataModel } from 'Models'

export const DEFAULT_DRAWER_WIDTH = '50%'
export const DEFAULT_TABLE_PAGE_SIZE = 30
export const DEFAULT_REQUEST_PARAMS = [1, 1000]
export const ACCEPTED_FILES = '.jpeg, .pdf, .jpg, .png, .tiff, .tif, .mp3'
export const ACCEPTED_FILES_TABLE = '.xls, .xlsx, .csv'
export const ACCEPTED_FILES_STATUSES = '.xls, .xlsx'
export const MAX_FILE_SIZE = 5 * 1024 * 1024
export const MAX_FILE_SIZE_ARCHIVE_ACT = 50 * 1024 * 1024
export const MAX_FILE_SIZE_XLSX_ACT = 10 * 1024 * 1024
export const MAX_BIG_FILE_SIZE_ARCHIVE_ACT = 100 * 1024 * 1024
export const MAX_FILE_SIZE_VIDEO = 500 * 1024 * 1024
export const MAX_MERCHANT_LOGO_FILE_SIZE = 0.5 * 1024 * 1024
export const BYTES_IN_MEGABYTE = 1024 ** 2
export const MAX_FILES_COUNT = 5

export enum DatePeriod {
	MONTH = 'month',
	QUARTER = 'quarter',
	YEAR = 'year',
	CUSTOM = 'custom',
}
export const DAYS_OF_WEEK = [
	'monday',
	'tuesday',
	'wednesday',
	'thursday',
	'friday',
	'saturday',
	'sunday',
]
export const TRANSLATE_DAYS_OF_WEEK = {
	monday: 'Понедельник',
	tuesday: 'Вторник',
	wednesday: 'Среда',
	thursday: 'Четверг',
	friday: 'Пятница',
	saturday: 'Суббота',
	sunday: 'Воскресенье',
}

export const TIME_FORMAT = 'HH:mm'
export const TIME_FORMAT_FULL = 'HH:mm:ss'
export const DATE_FORMAT = 'DD.MM.YYYY'
export const DATE_FORMAT_SHORT = 'DD.MM.YY'
export const DATE_AND_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const DATE_AND_TIME_FORMAT_REVERSE = 'DD.MM.YYYY HH:mm'
export const DATE_AND_TIME_FORMAT_LOGS = 'DD-MM-YYYY, HH:mm:ss'
export const DATE_FORMAT_FOR_BACKEND = 'YYYY-MM-DD'
export const YEAR_FORMAT = 'YYYY'
export const DEFAULT_WORKING_DAY = {
	begin: '7:00',
	end: '23:00',
}
export const DEFAULT_TIME_FROM = '00:00:00'
export const DEFAULT_TIME_TO = '23:59:59'

export const MILLISECOND_IN_DAY = 8.64e7

export const MOMENT_TIME_FORMAT = 'LT'
export const MOMENT_DATE_FORMAT = 'LL'

export const INPUT_TITLE_MAX_LENGTH = 80
export const INPUT_TEXT_MAX_LENGTH = 500

export const NEED_STATISTICS_OKVEDS = [
	'77.11',
	'77.3',
	'77.12',
	'64.99',
	'68.31.11',
	'68.31',
	'68.31.1',
	'68.31.12',
	'66.19.99.130',
	'66.19.99.131',
	'66.19.61',
]

export const NEWS_LENGTH = 80
export const EXTENDED_REQUIREMENTS_REGIONS = [
	'36', // Воронежская область
	'75', // Забайкальский край
	'30', // Астраханская область
	'29', // Архангельская область
]

export const KNOWLEDGE_TABLE_OF_CONTENT_DEPTH = 3

export const SUCCESS_CERTIFICATE_FIELDS = ['SN', 'G', 'T', 'CN']

export enum ORDER_DIRECTION {
	ASC = 'asc',
	DESC = 'desc',
}

export const TAX_FORM = {
	OSN: 'osn',
}

export const TIME_LIMIT = 3000

export const TIME_LIMIT_FILTER = 2000

export const MIN_FIND_LENGTH = 2

export const CARD_TITLE_LENGTH = 40

export enum DaysOfWeek {
	MONDAY,
	TUESDAY,
	WEDNESDAY,
	THURSDAY,
	FRIDAY,
	SATURDAY,
	SUNDAY,
}

export const NEED_ADD_PROPS_CHANNEL_NAME = ['NKON', 'MFCN']
export const SPACE_SYMBOL = '—'
export const ALL_GROUP_NOTIFICATION = 'total'

export const PARAMS_FOR_USER_CHECK = {
	only: `id,kpp,bik,checking_account,kbk,payment_account,oktmo,incorporation_form,taxation_form_id,
	free_tax_basis,free_tax_expiration_date,partner_type`,
}

export const PARAMS_IS_CHECK_PARTNER_PAYMENT = {
	KIND: 'legal',
	PARTNER_TYPE: 'agent',
}

export enum BREAKPOINTS {
	SCREEN_MOBILE = 375,
	SCREEN_SM = 578,
	SCREEN_MD = 768,
	SCREEN_LG = 992,
	SCREEN_XL = 1200,
	SCREEN_XXL = 1600,
	SCREEN_XXXL = 1920,
}

export const UNKNOWN = 'Неизвестно'

export const HELPER_FIELD_PREFIX = 'helper_'

export const AGE_WHEN_PASSPORT_CAN_BE_RECEIVED = 14

export const PASSPORT_CHANGE_AGE_20 = 20

export const PASSPORT_CHANGE_AGE_45 = 45

export const PASSPORT_VALIDITY_PERIOD_DAYS = 90

export enum MODAL_SIZE {
	XS = 520,
	S = 600,
	M = 832,
	XL = 936,
}

export const MENU_KIND = 'menu_section'

export enum GENDER {
	MALE = 'male',
	FEMALE = 'female',
}

export const GENDER_TRANSLATE = {
	[GENDER.MALE]: 'Мужской',
	[GENDER.FEMALE]: 'Женский',
}

export const GenderSelectItems = Object.keys(GENDER_TRANSLATE).map(
	(key): ShortDataModel => ({
		id: key,
		name: GENDER_TRANSLATE[key],
	})
)

export const SECOND_LIMIT_TIMER = 180

export enum WeekDays {
	Пн = 'Понедельник',
	Вт = 'Вторник',
	Ср = 'Среда',
	Чт = 'Четверг',
	Пт = 'Пятница',
	Сб = 'Суббота',
	Вс = 'Воскресенье',
}

export const LengthInnIP = 12
export const LengthInnUL = 10
export enum ORIENTATION {
	VERTICAL = 'vertical',
	HORIZONTAL = 'horizontal',
}

export const DEFAULT_LANGUAGE = 'ru'

export const CLOSE_ANIMATION = 500
